import axios from 'axios';
import Idx from 'idx';

const WadoDevAxiosInstance = axios.create({
	// baseURL: `https://wadodev.i-medical.biz/api/`,
	baseURL: `${process.env.REACT_APP_IMAGE_SERVER_URL}`,
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json",
	},
	// milliseconds * seconds * minutes
	timeout: 1000 * 60 * 2,
});
// Add a request interceptor
WadoDevAxiosInstance.interceptors.request.use((config) => config, (error) => Promise.reject(error));

// Add a response interceptor
WadoDevAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (Idx(error, (_) => _.response.data)) {
      const errorDetail = {
        code: error.response.status,
        message: error.response.data.message,
        title:  error.response.data.title
      };

      return Promise.reject(errorDetail);
    }

    return Promise.reject(error);
  },
);

export default WadoDevAxiosInstance;
